import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import {
  Autocomplete,
  CircularProgress,
  Grid2 as Grid,
  TextField,
} from '@mui/material';
import { WButton } from '@wareclouds/wareclouds-ui';
import { useTranslation } from 'react-i18next';
import {
  useCrossdockingContext,
  useGetRouteWareclouds,
} from '../../../application/hooks';
import { useEffect, useState } from 'react';

export default function Layout({ children, isLoadingLayout }) {
  const { t } = useTranslation(['button']);
  const { data: wareclouds, isLoading } = useGetRouteWareclouds();
  const [selectedWarecloud, setSelectedWarecloud] = useState(null);
  const {
    filters: crossdockingFilters,
    setFilters: setCrossdockingFilters,
    setOpenManualReceiving,
    setOpenBarcodeScanner,
  } = useCrossdockingContext();

  useEffect(() => {
    if (crossdockingFilters.idWarecloud) {
      setSelectedWarecloud(
        wareclouds.find(
          (warecloud) => warecloud.value === crossdockingFilters.idWarecloud
        )
      );
    } else {
      setSelectedWarecloud(null);
    }
  }, [crossdockingFilters, wareclouds]);

  const onSubmit = (data) => {
    setCrossdockingFilters({
      ...crossdockingFilters,
      idWarecloud: data?.warecloud?.value || '',
    });
  };

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <WButton
          variant="contained"
          label={t('read_barcode', { ns: 'button' })}
          startIcon={<PhotoCameraIcon />}
          onClick={() => {
            setOpenBarcodeScanner(true);
          }}
          isDisabled={isLoadingLayout}
          fullWidth
        />
      </Grid>
      <Grid size={12}>
        <WButton
          variant="outlined"
          label={t('manual_delivery', { ns: 'button' })}
          onClick={() => {
            setOpenManualReceiving(true);
          }}
          isDisabled={isLoadingLayout}
          fullWidth
        />
      </Grid>
      <Grid size={12}>
        <Autocomplete
          value={selectedWarecloud}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          getOptionLabel={(option) => option.label}
          options={wareclouds ?? []}
          loading={isLoading}
          onChange={(_, value) => {
            onSubmit({ warecloud: value });
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              label="Warecloud"
              disabled={isLoadingLayout}
              slotProps={{
                input: {
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {isLoading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                },
              }}
            />
          )}
        />
      </Grid>
      <Grid size={12}>{children}</Grid>
    </Grid>
  );
}
